import React from 'react';
import ReactContentLoader from 'react-content-loader';

import useMedia from 'hooks/useMedia';
import colors from 'styles/themes/colors';
import { rgba } from 'polished';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import {
  FakeDropdown,
  FakeButtonWrapper,
  FakeButton,
} from 'components/base/SkeletonLoader/FakeInteractive';
import Box from 'components/elements/Box';
import AgeTrendLoader from './AgeTrendLoader';
import { trendTypes } from 'components/data-containers/PerformanceTrend/AudienceTrendComponent';
import { ControlWrapper } from '../AgeOverTime.styles';

import { LoaderWrapper } from './AgeTrendLoader';
interface ISkeletonLoaderProps {
  isNarrowScreen?: boolean;
  showPeriodDropdown?: boolean;
  showToolbarDropdown?: boolean;
  title: string;
}

const SkeletonLoader: React.FC<ISkeletonLoaderProps> = (props) => {
  const { isNarrowScreen, showPeriodDropdown, showToolbarDropdown, title } =
    props;

  const isSmallScreen = useMedia('(max-width: 40em)');

  const toggleOptions = trendTypes.map((tType: any, index): any => ({
    label: tType.displayName,
    value: tType.id,
    active: index === 0,
  }));

  return (
    <GenericComponent
      title={title}
      loading={true}
      isNarrowScreen={isNarrowScreen}
      showToolbarDropdown={showToolbarDropdown}
    >
      <AnimatedLoadingWrapper loading={true}>
        {showPeriodDropdown && (
          <ControlWrapper>
            <FakeButtonWrapper>
              {toggleOptions &&
                toggleOptions.map((option: any) => (
                  <FakeButton key={option.value} active={option.active}>
                    {option.label}
                  </FakeButton>
                ))}
            </FakeButtonWrapper>
            <FakeDropdown active>View By Last 30 days</FakeDropdown>
          </ControlWrapper>
        )}

        <Box width="100%">
          <LoaderWrapper>
            <ReactContentLoader
              speed={1}
              foregroundColor={colors.Sand}
              backgroundColor={rgba(colors.LightGrey, 0.6)}
              height={isSmallScreen ? 50 : 20}
            >
              {isSmallScreen ? (
                <>
                  <rect width="100" height="20" x="10" y="0" />
                  <rect width="100" height="20" x="185" y="0" />
                  <rect width="100" height="20" x="10" y="30" />
                  <rect width="100" height="20" x="185" y="30" />
                </>
              ) : (
                <>
                  <rect width="50" height="10" x="0" y="0" />
                  <rect width="50" height="10" x="65" y="0" />
                  <rect width="50" height="10" x="130" y="0" />
                  <rect width="50" height="10" x="195" y="0" />
                </>
              )}
            </ReactContentLoader>
          </LoaderWrapper>
          <AgeTrendLoader />
        </Box>
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
};

export default SkeletonLoader;
